import { Button, Checkbox, Flex, Heading, Icon, IconButton, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BiCheck, BiFile, BiTransfer } from "react-icons/bi";
import { FaArrowLeft, FaArrowRight, FaColumns, FaDownload, FaEdit, FaFileInvoiceDollar, FaFilter, FaPlus, FaSync, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import TabButton from "../../components/Buttons/TabButton";
import AddDocument from "../../components/Modals/AddDocument";
import { GET, PUT } from "../../utils/ApiRequestProvider";
import EditModal, { EditModalProps } from "./EditModal";
import { ProcessingText } from "../../components/misc/Processing";

export interface PaginationType {
    currentPage: number;
    totalPages: number;
    totalRecords: number;
}

export interface SaleInvoice {
    docId: number;
    docType: string;
    customerName: string;
    invDate: string;
    invCurAmt: string;
    baseCurAmt: string;
    category: string;
    paymentMethod: string;
    status: string;
}

export default function PurchaseInvoices() {
    const toast = useToast();
    const business = useSelector((state: any) => state.selections.value?.business);
    const [selectedTab, setSelectedTab] = useState<string>("Uploaded");
    const [selectedDocuments, setSelectedDocuments] = useState<Array<any>>([]);
    const [paginationQuery, setPaginationQuery] = useState({ page: 1, pageSize: 10 });
    const [pagination, setPagination] = useState<PaginationType>({ currentPage: 0, totalPages: 0, totalRecords: 0 });
    const [documents, setDocuments] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);
    const [, setShowFilters] = useState(false);

    const handleBulkDelete = async () => {
        if (selectedDocuments.length === 0) {
            toast({ title: 'No document selected', status: 'warning', duration: 1200, position: 'top-right' });
            return;
        }
        if (!window.confirm(`Delete ${selectedDocuments.length} document(s)?`)) return;
        try {
            await PUT('/api/Documents/bulkDelete', { documentIds: selectedDocuments });
            toast({ title: 'Deleted', status: 'success', duration: 1200, position: 'top-right' });
            setSelectedDocuments([]);
            FetchList();
        } catch {
            toast({ title: 'Delete failed', status: 'error', duration: 1500, position: 'top-right' });
        }
    };
    const [editModalProps, setEditModalProps] = useState<EditModalProps>({
        selectedDocument: null,
        documents,
        isOpen: false,
        onClose: onEditModalClose
    });

    function onEditModalOpen(selectedDocument: any) {
        if(selectedDocument !== null){
            if(selectedDocument.status === "Data Entered"){
                setEditModalProps({ ...editModalProps, selectedDocument, isOpen: true })
            }
        }
    }

    function onEditModalClose() {
        setEditModalProps({ ...editModalProps, isOpen: false })
    }

    const convertDate = (date: string) => {
        const datehistory = new Date(date).toUTCString()
        return datehistory;
    }

    useEffect(() => {
        FetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business, selectedTab, paginationQuery]);

    useEffect(() => {
        setEditModalProps({ ...editModalProps, documents });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents]);

    const DownloadFile = async () => {
        if(selectedDocuments.length === 0 || selectedDocuments.length === undefined){
            toast({
                title: 'No Document Selected!',
                description: 'Please select a document to download!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
            return;
        }
        const response = await GET(`/api/Documents/exportDocument?doc=${selectedDocuments[0]}`);
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'data:application/vnd.ms-excel;base64'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', selectedDocuments[0]+'.csv');
        document.body.appendChild(link);
        link.click();
    }

    async function FetchList() {
        setLoading(true);
        try {
            if (business) {
                const res = await GET(`/api/Documents/${business?.id}/PurchaseInvoice/list?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}&status=${selectedTab}&sortColumn=Date&sortOrder=desc`);
                setPagination(res.data.pagination);
                setDocuments(res.data.documents);
                
                toast({
                    title: 'Data Fetched',
                    description: 'Data has been fetched successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    const handleSelectedDocument = (e: any) => {
        if (e.target.checked) {
            setSelectedDocuments([...selectedDocuments, e.target.id]);
        } else {
            setSelectedDocuments(selectedDocuments.filter((doc) => doc !== e.target.id));
        }
    }

    const handleApproveDocument = async (docno: any) => {
        var arr: any[] = [docno];
        var arr_to_approve = {'documents_ids': arr, 'status': "Exported"};
        try {
            const res = await PUT(`/api/Documents/exported`, arr_to_approve);
            if (res.status === 'success') {
                toast({
                    title: 'Document Approved',
                    description: 'Document have been approved successfully!',
                    status: 'success',
                    isClosable: false,
                    duration: 1000,
                    position: 'top-right'
                });
                FetchList();
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
}

    const [isAddFileModalOpen, setIsAddFileModalOpen] = useState(false);

    function onAddFileModalClose() {
        setIsAddFileModalOpen(false);
    }
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaFileInvoiceDollar}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Purchase Invoices</Heading>
                            <Text fontSize={'sm'}>All expenses invoices, receipts & refunds documents</Text>
                        </Stack>
                    </Stack>
                    <Stack
                        direction={'row'}
                    >
                        <TabButton
                            active={selectedTab === ""}
                            onClick={() => setSelectedTab("")}
                        >
                            All
                        </TabButton>
                        <TabButton
                            active={selectedTab === "Uploaded"}
                            onClick={() => setSelectedTab("Uploaded")}
                        >
                            New
                        </TabButton>
                        <TabButton
                            active={selectedTab === "Data Entered"}
                            onClick={() => setSelectedTab("Data Entered")}
                        >
                            Processed
                        </TabButton>
                        <TabButton
                            active={selectedTab === "Exported"}
                            onClick={() => setSelectedTab("Exported")}
                        >
                            Approved
                        </TabButton>
                        <TabButton
                            active={selectedTab === "Reports"}
                            onClick={() => setSelectedTab("Reports")}
                        >
                            Reports
                        </TabButton>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<BiCheck />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Approve
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaEdit />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Bulk Edit
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaColumns />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Columns
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<BiTransfer />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                        >
                            Transfer
                        </Button>
                    </Stack>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaPlus />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={() => setIsAddFileModalOpen(true)}
                        >
                            Add Files
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaDownload />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={() => DownloadFile()}
                        >
                            Export CSV
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={FetchList}
                        >
                            Refresh
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaFilter />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={() => setShowFilters((v) => !v)}
                        >
                            Filter
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaTrash />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.400' }}
                            _active={{ bg: 'primary.400' }}
                            onClick={handleBulkDelete}
                        >
                            Delete
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} zIndex={1} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    color={'white'}
                                    isNumeric
                                >
                                    Doc ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Doc Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Supplier Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Invoice Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    <Text fontSize={'sm'} fontWeight={'bold'}>Amount</Text>
                                    <Text fontSize={'sm'} fontWeight={'light'}>Inv. Currency</Text>
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    <Text fontSize={'sm'} fontWeight={'bold'}>Amount</Text>
                                    <Text fontSize={'sm'} fontWeight={'light'}>Base Currency</Text>
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Category
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Payment Method
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    File Name
                                </Th>
                                <Th
                                    color={'white'}
                                    colSpan={2}
                                    textAlign={'center'}
                                >
                                    Actions
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                documents?.length > 0 ?
                                    (
                                        documents?.map((doc, idx) => (
                                            <Tr key={idx}>
                                                <Td display={'flex'} justifyContent={'space-between'} ><Checkbox colorScheme="primary" id={doc?.invoiceNumber} onChange={handleSelectedDocument} />
                                                {doc?.invoiceNumber}</Td>
                                                <Td>{doc?.documentType}</Td>
                                                <Td>{doc?.contact?.name}</Td>
                                                <Td>{doc?.invoiceDate !== null && convertDate(doc?.invoiceDate)}</Td>
                                                <Td>{doc?.grossAmount}</Td>
                                                <Td>{doc?.convertedGrossAmount}</Td>
                                                <Td>{doc?.category?.category}</Td>
                                                <Td>{doc?.paymentMethod?.bankName}</Td>
                                                <Td>{<ProcessingText status={doc?.status} />}</Td>
                                                <Td>
                                                    <Text fontSize={'xs'} isTruncated maxW={'200px'}>
                                                        {doc?.fileName || doc?.file?.split(/[\\/]/).pop() || '—'}
                                                    </Text>
                                                </Td>

                                                    {doc?.status === "Data Entered" ?
                                                    <Td as={Stack} spacing={4} direction={'row'}>
                                                        <Button
                                                            size={'sm'}
                                                            leftIcon={<FaEdit />}
                                                            color={'white'}
                                                            bg={'primary.400'}
                                                            _hover={{ bg: 'primary.400' }}
                                                            _active={{ bg: 'primary.400' }}
                                                            onClick={() => handleApproveDocument(doc)}
                                                        >
                                                            Approve
                                                        </Button> 
                                                        <IconButton
                                                        aria-label="Document"
                                                        icon={<BiFile />}
                                                        color={'green.400'}
                                                        bg={'transparent'}
                                                        fontSize={'xl'}
                                                        rounded={'full'}
                                                        onClick={() => onEditModalOpen(doc)}
                                                    />
                                                    </Td>
                                                    :
                                                    <Td>
                                                        {'No Actions'}
                                                    </Td>
                                                    }
                                                    
                                                
                                            </Tr>
                                        ))
                                    )
                                    :
                                    (
                                        loading ?
                                            (
                                                <Tr>
                                                    <Td colSpan={9}>
                                                        <Flex gap={2} justify={'center'} align={'center'}>
                                                            <Text>Loading</Text>
                                                            <Spinner size={'sm'} color={'primary.400'} />
                                                        </Flex>
                                                    </Td>
                                                </Tr>
                                            )
                                            :
                                            (
                                                <Tr>
                                                    <Td textAlign={'center'} colSpan={9}>No Data Available</Td>
                                                </Tr>
                                            )
                                    )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {documents?.length} of {pagination.totalRecords} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select
                            onChange={(e) => {
                                setPaginationQuery({ page: 1, pageSize: parseInt(e.target.value) });
                            }}
                        >
                            <option selected value={'5'}>5 Per Page</option>
                            <option value={'10'}>10 Per Page</option>
                            <option value={'25'}>25 Per Page</option>
                            <option value={'50'}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                                disabled={pagination.currentPage <= 1}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage - 1 })}
                            />
                            <IconButton
                                aria-label="Next"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                                disabled={pagination.currentPage >= pagination.totalPages}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage + 1 })}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <EditModal {...editModalProps} Refresh={FetchList} />
            <AddDocument isOpen={isAddFileModalOpen} onClose={onAddFileModalClose} DocType={"Purchase Invoice"} RefreshList={FetchList} />
        </Stack >
    )
}